<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg783"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs787"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath841"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path839" /></clipPath></defs><g
     id="g789"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g791"
       transform="translate(142.8379,458.6602)"><path
         d="M 0,0 H 142.16"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path793" /></g><g
       id="g795"
       transform="translate(142.8379,412.832)"><path
         d="M 0,0 H 142.16"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path797" /></g><g
       id="g799"
       transform="translate(120.3496,120.2612)"><path
         d="M 0,0 H 36.103"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path801" /></g><g
       id="g803"
       transform="translate(195.8662,120.2612)"><path
         d="M 0,0 H 36.103"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path805" /></g><g
       id="g807"
       transform="translate(271.3828,120.2612)"><path
         d="M 0,0 H 36.103"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path809" /></g><g
       id="g811"
       transform="translate(120.3496,86.5142)"><path
         d="M 0,0 H 36.103"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path813" /></g><g
       id="g815"
       transform="translate(195.8662,86.5142)"><path
         d="M 0,0 H 36.103"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path817" /></g><g
       id="g819"
       transform="translate(271.3828,86.5142)"><path
         d="M 0,0 H 36.103"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path821" /></g><g
       id="g823"
       transform="translate(120.3496,52.7671)"><path
         d="M 0,0 H 36.103"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path825" /></g><g
       id="g827"
       transform="translate(195.8662,52.7671)"><path
         d="M 0,0 H 36.103"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path829" /></g><g
       id="g831"
       transform="translate(271.3828,52.7671)"><path
         d="M 0,0 H 36.103"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path833" /></g><g
       id="g835"><g
         id="g837"
         clip-path="url(#clipPath841)"><g
           id="g843"
           transform="translate(325.1191,473.8984)"><path
             d="M 0,0 C 0,16.901 13.701,30.602 30.602,30.602 H -189.77 c -18.023,0 -32.633,-14.611 -32.633,-32.634 v -98.577 c 0,-6.645 5.386,-12.032 12.031,-12.032 h 198.341 c 6.644,0 12.031,5.387 12.031,12.032 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path845" /></g><g
           id="g847"
           transform="translate(353.4121,104.5127)"><path
             d="m 0,0 v 32.359 c 0,21.144 1.659,42.257 4.961,63.142 v 0 c 3.303,20.886 4.962,41.998 4.962,63.143 v 100.097 c 0,20.712 -16.791,37.503 -37.504,37.503 h -0.712"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path849" /></g><g
           id="g851"
           transform="translate(102.7158,400.7568)"><path
             d="m 0,0 h -0.712 c -20.713,0 -37.504,-16.791 -37.504,-37.503 v -100.098 c 0,-21.144 1.659,-42.256 4.962,-63.142 v 0 c 3.302,-20.885 4.961,-41.998 4.961,-63.143 v -98.772 c 0,-16.9 13.699,-30.599 30.599,-30.599 h 217.792 c 16.899,0 30.598,13.699 30.598,30.599 v 30.75"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path853" /></g><g
           id="g855"
           transform="translate(105.1553,293.1997)"><path
             d="m 0,0 v 21.577 c 0,4.489 3.639,8.128 8.128,8.128 h 201.268 c 4.49,0 8.128,-3.639 8.128,-8.128 v -78.248 c 0,-4.489 -3.638,-8.128 -8.128,-8.128 H 8.128 C 3.639,-64.799 0,-61.16 0,-56.671 v 21.61"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path857" /></g><g
           id="g859"
           transform="translate(151.96,159.9302)"><path
             d="m 0,0 h -31.886 c -3.461,0 -6.469,2.375 -7.272,5.742 l -4.897,20.533 c -1.121,4.699 2.442,9.211 7.272,9.211 H 0 c 4.129,0 7.477,-3.347 7.477,-7.476 V 7.476 C 7.477,3.347 4.129,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path861" /></g><g
           id="g863"
           transform="translate(233.3057,159.9302)"><path
             d="m 0,0 h -38.776 c -4.129,0 -7.476,3.347 -7.476,7.476 V 28.01 c 0,4.129 3.347,7.476 7.476,7.476 H 0 c 4.129,0 7.476,-3.347 7.476,-7.476 V 7.476 C 7.476,3.347 4.129,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path865" /></g><g
           id="g867"
           transform="translate(307.7607,159.9302)"><path
             d="m 0,0 h -31.886 c -4.129,0 -7.476,3.347 -7.476,7.476 V 28.01 c 0,4.129 3.347,7.476 7.476,7.476 H 4.897 c 4.831,0 8.393,-4.512 7.272,-9.211 L 7.272,5.742 C 6.47,2.375 3.461,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path869" /></g><g
           id="g871"
           transform="translate(363.335,338.5435)"><path
             d="M 0,0 H 53.563 C 36.662,0 22.961,13.701 22.961,30.602 v 105.812 c -0.559,16.409 -14.029,29.543 -30.575,29.543 h -0.003 0.003"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path873" /></g><g
           id="g875"
           transform="translate(416.2393,338.5605)"><path
             d="m 0,0 c 17.208,0.104 31.261,13.465 31.261,30.585 v 50.682 c 0,7.208 -5.844,13.051 -13.052,13.051 h -48.152"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path877" /></g></g></g></g></svg>
</template>
